import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AvatarComponent } from './components/avatar/avatar.component';
import { BarChartComponent } from './components/chart/bar-chart.component';
import { MaterialDialog } from './components/dialog/dialog.component';
import { MatDialogActions, MatDialogClose, MatDialogContent, MatDialogModule, MatDialogTitle } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { AlertComponent } from './components/alert/alert.component';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { HttpClientModule } from '@angular/common/http';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatExpansionModule } from '@angular/material/expansion';
import { TitleComponent } from './components/title/title.component';
import { DataPersonComponent } from './components/data-person/data-person.component';
import { NgxMaskModule } from 'ngx-mask';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HoursFormComponent } from './components/hours-form/hours-form.component';
import { QualificationsComponent } from './components/qualifications/qualifications.component';
import { SearchCepComponent } from './components/map/search-cep/search-cep.component';
import { MapViewComponent } from './components/map/map-view.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { SecretaryContactsComponent } from './components/secretary-contacts/secretary-contacts.component';
import { ScheduleItemComponent } from './components/schedule-item/schedule-item.component';
import { LibremapViewComponent } from './components/libremap-view/libremap-view.component';
import { TranslateGenderPipe } from 'app/core/pipes/translater-gender.pipe';
import { HealthPlanFormComponent } from './components/health-plan-form/health-plan-form.component';
import { RequestHoursChangesDetails } from './components/request-hours-changes-details/request-hours-changes-details';
import { ConfirmationPaymentCodeComponent } from './components/confirmation-payment-code/confirmation-payment-code.component';
import { ChangeScheduleMethodComponent } from './components/change-schedule-method/change-schedule-method.component';
import { PractitionerViewComponent } from './components/practitioner-data/practitioner-view.component';
import { ScheduleSpecialistComponent } from './components/schedule-specialist/schedule-specialist.component';
import { PractitionerInfoDialogComponent } from './components/practitioner-info-dialog/practitioner-info-dialog.component';
import { OrganizationInfoDialogComponent } from './components/organization-info-dialog/organization-info-dialog.component';
import { ScheduleSpecialistInfoComponent } from './components/schedule-specialist-info/schedule-specialist-info.component';
import { ScheduleSpecialistCardComponent } from './components/schedule-specialist-card/schedule-specialist-card.component';
import { ScheduleSpecialistByOrganizationComponent } from './pages/schedule-specialist-by-organization/schedule-specialist-by-organization.component';
import { SheduleOrganizationDealerComponent } from './components/shedule-organization-dealer/shedule-organization-dealer.component';
import { ScheduleOrganizationCardComponent } from './components/schedule-organization-card/schedule-organization-card.component';
import { ScheduleOrganizationHourComponent } from './components/schedule-organization-hour/schedule-organization-hour.component';
import { ScheduleSelectPatientComponent } from './components/schedule-select-patient/schedule-select-patient.component';
import { ScheduleServiceOptionComponent } from './components/schedule-service-option/schedule-service-option.component';
import { TranslateMessagePipe } from 'app/core/pipes/translater-message.pipe';
import { UtilsService } from './utils.service';
import { TranslateBlockDaysPipe } from 'app/core/pipes/blockdays-type.pipe';
import { OnboardingPagarmeComponent } from './components/onboarding-pagarme/onboarding-pagarme.component';

@NgModule({
  declarations: [
    AlertComponent,
    AvatarComponent,
    BarChartComponent,
    TitleComponent,
    DataPersonComponent,
    HoursFormComponent,
    QualificationsComponent,
    MapViewComponent,
    SearchCepComponent,
    PaginationComponent,
    SecretaryContactsComponent,
    MaterialDialog,
    ScheduleItemComponent,
    LibremapViewComponent,
    TranslateGenderPipe,
    TranslateMessagePipe,
    TranslateBlockDaysPipe,
    HealthPlanFormComponent,
    RequestHoursChangesDetails,
    ConfirmationPaymentCodeComponent,
    RequestHoursChangesDetails,
    ChangeScheduleMethodComponent,
    PractitionerViewComponent,
    ScheduleSpecialistComponent,
    PractitionerInfoDialogComponent,
    OrganizationInfoDialogComponent,
    ScheduleSpecialistInfoComponent,
    ScheduleSpecialistCardComponent,
    ScheduleSpecialistByOrganizationComponent,
    SheduleOrganizationDealerComponent,
    ScheduleOrganizationCardComponent,
    ScheduleOrganizationHourComponent,
    ScheduleSelectPatientComponent,
    ScheduleServiceOptionComponent,
    OnboardingPagarmeComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatListModule,
    MatSidenavModule,
    MatToolbarModule,
    MatMenuModule,
    MatTableModule,
    MatPaginatorModule,
    MatTabsModule,
    MatDialogModule,
    MatDatepickerModule,
    MatInputModule,
    HttpClientModule,
    MatGridListModule,
    MatCardModule,
    MatCheckboxModule,
    MatRadioModule,
    MatSelectModule,
    MatButtonToggleModule,
    MatChipsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSlideToggleModule,
    MatAutocompleteModule,
    MatExpansionModule,
    MatButtonModule,
    MatToolbarModule,
    MatCardModule,
    MatListModule,
    NgxMaskModule.forRoot(),

  ],
  exports: [
    NgxMaskModule,
    AlertComponent,
    BarChartComponent,
    TitleComponent,
    HoursFormComponent,
    QualificationsComponent,
    MapViewComponent,
    SearchCepComponent,
    PaginationComponent,
    SecretaryContactsComponent,
    MaterialDialog,
    AvatarComponent,
    ScheduleItemComponent,
    HoursFormComponent,
    DataPersonComponent,
    LibremapViewComponent,
    HealthPlanFormComponent,
    TranslateBlockDaysPipe,
    TranslateGenderPipe,
    TranslateMessagePipe,
    ConfirmationPaymentCodeComponent,
    PractitionerViewComponent,
    ScheduleSpecialistComponent,
    PractitionerInfoDialogComponent,
    OrganizationInfoDialogComponent,
    ScheduleSpecialistByOrganizationComponent,
    ScheduleSelectPatientComponent,
    ScheduleServiceOptionComponent,
    OnboardingPagarmeComponent
  ],
  providers: [UtilsService]
})
export class SharedModule {}
